'use client';
import _extends from '@babel/runtime/helpers/extends';
import React__default, { forwardRef, useState, useEffect } from 'react';
import { clientSide } from '../../utils/dom.js';

const CountdownClock = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    duration,
    onComplete,
    storage: storageType = 'session',
    name = 'default',
    ...rest
  } = _ref;
  const [remainingTime, setRemainingTime] = useState(duration);
  useEffect(() => {
    if (!clientSide) return;
    const storage = storageType === 'local' ? localStorage : sessionStorage;
    const endTime = Number(storage.getItem(`${name}CountdownClockEndTime`));
    if (endTime) {
      const currentTime = new Date().getTime();
      const remainingSeconds = Math.ceil((endTime - currentTime) / 1000);
      setRemainingTime(remainingSeconds > 0 ? remainingSeconds : 0);
    }
    const countdownInterval = setInterval(() => {
      setRemainingTime(prevTime => {
        if (prevTime > 0) {
          return prevTime - 1;
        } else {
          clearInterval(countdownInterval);
          if (onComplete) {
            onComplete();
          }
          return 0;
        }
      });
    }, 1000);
    return () => {
      clearInterval(countdownInterval);
    };
  }, [duration, onComplete, storageType]);
  useEffect(() => {
    if (!clientSide) return;
    const storage = storageType === 'local' ? localStorage : sessionStorage;
    const currentTime = new Date().getTime();
    const endTime = currentTime + remainingTime * 1000;
    storage.setItem(`${name}CountdownClockEndTime`, endTime.toString());
  }, [remainingTime, storageType]);
  const formatTime = time => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };
  return /*#__PURE__*/React__default.createElement("time", _extends({
    ref: ref,
    "data-testid": `${name}-countdown-clock`
  }, rest), formatTime(remainingTime));
});
CountdownClock.displayName = 'CountdownClock';

export { CountdownClock };
